import { usePollingContext } from 'components/newIdentifyMethods/VideoScreen/contexts/PollingContext';
import { post } from 'utilities/APIRequestHelper';
import { useEffect } from 'react';
import { COMPLETED, PROGRAMMED } from 'constants/video/status';
import { getErrorFromStatusResponse } from '../../utils/requests/responses/getErrorFromStatusResponse';

export const useCaptureStatusPolling = ({ onComplete, onError }) => {
    const { startPolling, stopPolling } = usePollingContext();

    const getShouldContinuePollingFromResponse = (response = { ok: false }) => {
        const { ok, body, status } = response;
        if (status === 409) return false;

        return !ok || !body || body.status === PROGRAMMED;
    };

    const handleCaptureStatusFinished = (response = { ok: false }) => {
        const { ok, body } = response;
        const error = getErrorFromStatusResponse({ ok, data: body });
        if (error) return onError(error);

        return onComplete({ statusCode: COMPLETED, onboardingStatus: body?.onboardingStatus });
    };

    const startStatusPolling = () => {
        startPolling({
            asyncFetch: () => post('getCaptureStatus'),
            callback: getShouldContinuePollingFromResponse,
            callbackEnd: handleCaptureStatusFinished,
            delay: 1,
            retryOnFailure: true,
            retryAfter: 3,
            stopAfterRetries: 2,
        });
    };
    useEffect(() => {
        return () => {
            stopPolling();
        };
    }, []);

    return startStatusPolling;
};
